<div class="eiq-input-date__container">
  <span class="eiq-input-date__label">
    {{ label() }}
    <span class="eiq-input-date__hint">{{ hint() }}</span>
  </span>
  <mat-form-field appearance="outline" class="eiq-input-date__field" [subscriptSizing]="'dynamic'">
    <input
      #dateInput
      matInput
      [attr.data-testid]="testId() ? testId() + '-date' : null"
      [disabled]="disabled() || isFormDisabled"
      [matDatepicker]="picker"
      [errorStateMatcher]="errorStateMatcher"
      [min]="min()"
      [max]="max()"
      (input)="onInput($event)"
      (dateChange)="setValue($event)"
      (blur)="validateOnBlur($event)"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  @if (control.invalid && control.touched) {
    <div class="eiq-input-date__error">
      <eiq-validation-text [formCtrl]="control"></eiq-validation-text>
    </div>
  }
</div>
